import {fromJS, Map} from 'immutable';
import activeUsersActions from '../../actions/fortnite-game/activeUsers.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TimeScale} from '../../types';

export interface ActiveUsersDataItem {
    day: string;
    creativeAccountId: string;
    creativeIslandCode: string;
    unique_users: number;
}

const DEFAULT_DATA = {
    [TimeScale.LIVE]: {
        list: [],
        empty: []
    },
    [TimeScale.DAILY]: {
        list: [],
        empty: []
    },
    [TimeScale.WEEKLY]: {
        list: [],
        empty: []
    },
    [TimeScale.MONTHLY]: {
        list: [],
        empty: []
    }
};

export const DEFAULT_STATE = fromJS({
    data: DEFAULT_DATA,
    timeScale: TimeScale.LIVE,
    lastFetch: Date.now(),
    error: undefined,
    loading: false
});

export const activeUsersReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timeScale, data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case activeUsersActions.TYPES.GET_ACTIVE_USERS: {
            return state.merge({
                timeScale,
                error: undefined,
                loading: !silent
            });
        }

        case activeUsersActions.TYPES.GET_ACTIVE_USERS_COMPLETE: {
            return state
                .update('data', stateData => stateData.set(state.get('timeScale'), data))
                .merge({
                    lastFetch: Date.now(),
                    loading: false,
                    error
                });
        }

        case activeUsersActions.TYPES.GET_ACTIVE_USERS_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        case activeUsersActions.TYPES.RESET_DATA: {
            return state.merge({
                data: DEFAULT_DATA
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('activeUsers', activeUsersReducer);
